<div class="flex flex-col w-full gap-4 p-4">
  <app-dashboard-header *ngIf="showHeader" class="print:hidden">
    <div title class="flex items-center">
      <mat-icon title class="headerIcon" svgIcon="space_dashboard"></mat-icon>
      {{ 'Dashboard' | transloco }}
    </div>
    <div subMenu class="flex flex-row gap-2 submenu">
      <a
        mat-stroked-button
        class="mat-dense text-smaller pe-4"
        [routerLink]="'/project-d/' + this._project.id + '/dashboard'"
      >
        <mat-icon class="icon-size-4 me-1" svgIcon="space_dashboard"></mat-icon>
        {{ 'Main Dashboard' | transloco }}</a
      >
      <a
        *ngIf="_project.projectInfo.level <= 2"
        mat-stroked-button
        class="mat-dense text-smaller pe-4"
        [routerLink]="'/project-d/' + this._project.id + '/dashboard/cumulative'"
        routerLinkActive="mat-primary"
      >
        <mat-icon class="icon-size-4 me-1" svgIcon="dashboard"></mat-icon>
        {{ 'Cumulative Dashboard' | transloco }}</a
      >
      <a
        *ngIf="_project.getPermission(AccessLevel.VIEW_WEEKLY_REPORTS)"
        mat-stroked-button
        class="mat-dense text-smaller pe-4"
        [routerLink]="'/project-d/' + this._project.id + '/dashboard/weekly-report'"
        routerLinkActive="mat-primary"
      >
        <mat-icon class="icon-size-4 me-1" svgIcon="mat_solid:calendar_today"></mat-icon>
        {{ 'Weekly Report' | transloco }}</a
      >
    </div>
    <div actions>
      <button
        *ngIf="getDeletePermisiion()"
        mat-flat-button
        class="mat-dense min-w-0 me-2"
        color="warn"
        (click)="deleteWeeklyReport(weeklyReportDetails.id)"
        style="min-height: 30px"
        [loadingState]="reportRendering"
        appLoadingButton
        [matTooltip]="'Delete Report' | transloco"
      >
        <mat-icon class="" svgIcon="heroicons_solid:trash"></mat-icon>
      </button>
      <button
        mat-flat-button
        class="mat-dense min-w-0 me-2"
        color="primary"
        (click)="print()"
        style="min-height: 30px"
        [loadingState]="reportRendering"
        appLoadingButton
        [matTooltip]="'Print Report' | transloco"
      >
        <mat-icon svgIcon="mat_solid:print"></mat-icon>
      </button>
      <button
        *ngIf="_project.getPermission(AccessLevel.CREATE_WEEKLY_REPORTS)"
        mat-flat-button
        class="mat-dense min-w-0"
        color="primary"
        (click)="openWeeklyReportDialog()"
        style="min-height: 30px"
        [matTooltip]="'Generate Weekly Report' | transloco"
      >
        <mat-icon svgIcon="mat_solid:add"></mat-icon>
        <span>{{ 'Generate Weekly Report' | transloco }}</span>
      </button>
    </div>
  </app-dashboard-header>
  <!--Content-->
  <mat-accordion>
    <mat-expansion-panel #weeklyReportExpansionPanel [expanded]="true" id="print-view">
      <mat-expansion-panel-header class="print:hidden">
        <mat-panel-title>
          {{ 'Weekly Report' | transloco }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ngx-loading [show]="isLoading"></ngx-loading>

      <div *ngIf="!isLoading" class="flex flex-col bg-card p-4 gap-3 rounded-md">
        <div class="flex flex-row w-full p-4 items-center" (load)="checkImageLoading()">
          <div class="flex flex-row justify-between items-center w-full">
            <img
              [src]="_persona.logoFull"
              class="w-auto no-print report-images pe-2"
              style="max-height: 3.5rem"
            />

            <!--  for print only logo-->
            <img
              [src]="_persona.logoPrint || _persona.logoFull"
              class="w-auto print-only report-images pe-2"
              style="max-height: 3.5rem"
            />
            <div class="text-xl font-bold break-all max-w-full ps-2">
              {{ weeklyReportDetails.name | titlecase }}
            </div>
            <div
              class="flex flex-row justify-end gap-2 stakeholder-logos"
              *ngIf="
                weeklyReportDetails.consultant_image ||
                weeklyReportDetails.contractor_image ||
                weeklyReportDetails.supervision_image
              "
            >
              <div
                class="w-14 max-h-14 p-1 bg-accent-700 rounded-sm flex items-center content-center justify-center flex-wrap"
              >
                <img
                  *ngIf="weeklyReportDetails.consultant_image"
                  [ngSrc]="weeklyReportDetails.consultant_image + '?v=' + timestamp"
                  width="24"
                  height="24"
                  class="max-h-12 max-w-12 w-auto report-images"
                />
              </div>
              <div
                class="w-14 max-h-14 p-1 bg-accent-700 rounded-sm flex items-center content-center justify-center flex-wrap"
              >
                <img
                  *ngIf="weeklyReportDetails.contractor_image"
                  [ngSrc]="weeklyReportDetails.contractor_image + '?v=' + timestamp"
                  width="24"
                  height="24"
                  class="max-h-12 max-w-12 w-auto report-images"
                />
              </div>
              <div
                class="w-14 max-h-14 p-1 bg-accent-700 rounded-sm flex items-center content-center justify-center flex-wrap"
              >
                <img
                  *ngIf="weeklyReportDetails.supervision_image"
                  [ngSrc]="weeklyReportDetails.supervision_image + '?v=' + timestamp"
                  width="24"
                  height="24"
                  class="max-h-12 max-w-12 w-auto report-images"
                />
              </div>
            </div>
          </div>
        </div>
        <!--Report information-->
        <div class="grid grid-cols-12 w-full gap-4">
          <div class="col-span-8 rounded-md p-4 bg-accent-900">
            <!--Project Information-->
            <div class="flex flex-row w-full my-2">
              <span class="font-bold">{{ 'Project Information' | transloco }}</span>
            </div>
            <div class="flex flex-row w-full">
              <div class="flex flex-row w-full gap-2">
                <div class="flex gap-2 w-1/2">
                  <div
                    [ngClass]="_project.projectInfo.capacity ? 'w-1/2' : 'w-full'"
                    *ngIf="
                      (_project.projectInfo.totalAreaSpace === 0 &&
                        !_project.projectInfo.capacity) ||
                      _project.projectInfo.totalAreaSpace !== 0
                    "
                  >
                    <div class="text-sm">
                      {{ 'Total Area Space' | transloco }}
                    </div>
                    <div class="border rounded-md p-3 mt-1 mb-4 capitalize">
                      {{ _project.projectInfo.totalAreaSpace
                      }}<span
                        *ngIf="getAreaUnitLabel(_project.projectInfo.totalAreaUnit) as ub"
                        class="ms-1"
                        >{{ ub }}<sup>2</sup></span
                      >
                    </div>
                  </div>
                  <div
                    [ngClass]="
                      _project.projectInfo.capacity && _project.projectInfo.totalAreaSpace
                        ? 'w-1/2'
                        : 'w-full'
                    "
                    *ngIf="_project.projectInfo.capacity"
                  >
                    <div class="text-sm">
                      {{ 'Capacity' | transloco }}
                    </div>
                    <div class="border rounded-md p-3 mt-1 mb-4 capitalize">
                      {{
                        _project.projectInfo.capacity?.split(' ')[0] +
                          ' ' +
                          (_project.projectInfo.capacity?.split(' ')[1] | transloco)
                      }}
                    </div>
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="text-sm">
                    {{ 'Project Manager' | transloco }}
                  </div>
                  <div class="border rounded-md p-3 mt-1 mb-4 capitalize">
                    {{ weeklyReportDetails.project_manager_name | titlecase }}
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-row w-full">
              <div class="flex flex-row w-full gap-2">
                <div class="w-1/2">
                  <div class="text-sm">
                    {{ 'Start Date' | transloco }}
                  </div>
                  <div class="border rounded-md p-3 mt-1 mb-4 capitalize">
                    {{ _project.projectInfo.start_date | dateTransform: 'YYYY-MM-DD' : true }}
                  </div>
                </div>
                <div class="w-1/2">
                  <div class="text-sm">
                    {{ 'End Date' | transloco }}
                  </div>
                  <div class="border rounded-md p-3 mt-1 mb-4 capitalize">
                    {{ _project.projectInfo.end_date | dateTransform: 'YYYY-MM-DD' : true }}
                  </div>
                </div>
              </div>
            </div>

            <!--Report Information-->
            <div class="flex flex-row w-full my-2">
              <span class="font-bold">{{ 'Report Information' | transloco }}</span>
            </div>
            <div class="flex flex-row w-full">
              <div class="flex flex-row w-full gap-2">
                <div class="flex flex-row w-full">
                  <div class="flex flex-row w-full gap-2">
                    <div class="w-1/2">
                      <div class="text-sm">
                        {{ 'Start Date Weekly Report' | transloco }}
                      </div>
                      <div class="border rounded-md p-3 mt-1 mb-4 capitalize">
                        {{ weeklyReportDetails.start_date | dateTransform: 'YYYY-MM-DD' : true }}
                      </div>
                    </div>
                    <div class="w-1/2">
                      <div class="text-sm">
                        {{ 'End Date Weekly Report' | transloco }}
                      </div>
                      <div class="border rounded-md p-3 mt-1 mb-4 capitalize">
                        {{ weeklyReportDetails.end_date | dateTransform: 'YYYY-MM-DD' : true }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-span-4 h-full project-logo content-center p-4 bg-accent-900 rounded-md">
            <img [src]="_project.projectInfo.projectLogo" class="report-images" />
          </div>
        </div>

        <!--Graphs-->
        <div
          class="flex flex-col md:flex-row w-full items-center justify-between gap-4 graphs-section"
        >
          <!-- Progress Graphs -->
          <div
            class="flex flex-col w-full md:w-1/2"
            [ngClass]="[
              weeklyReportDetails.deviation ? 'md:w-1/3' : 'md:w-1/2',
              weeklyReportDetails.deviation ? 'graph-child' : 'graph-child-half'
            ]"
          >
            <div class="text-center p-4 bg-accent-900 rounded-t-md">
              <span class="text-md font-bold">{{ 'Progress' | transloco }}</span>
            </div>
            <div class="flex justify-center p-4 bg-accent-900 rounded-b-md" id="barChart">
              <div
                [ngClass]="
                  translateService.getActiveLang() === 'ar' ? 'changePosArabicVersion' : ''
                "
              >
                <apx-chart
                  #barChartRef
                  [series]="barChartOptions.series"
                  [chart]="barChartOptions.chart"
                  [dataLabels]="barChartOptions.dataLabels"
                  [plotOptions]="barChartOptions.plotOptions"
                  [yaxis]="barChartOptions.yaxis"
                  [legend]="barChartOptions.legend"
                  [fill]="barChartOptions.fill"
                  [stroke]="barChartOptions.stroke"
                  [tooltip]="barChartOptions.tooltip"
                  [theme]="barChartOptions.theme"
                  [colors]="barChartOptions.colors"
                  [xaxis]="barChartOptions.xaxis"
                ></apx-chart>
              </div>
            </div>
          </div>
          <!-- Financials Graph -->
          <div
            id="chart"
            class="flex w-full md:w-1/2"
            [ngClass]="[
              weeklyReportDetails.deviation ? 'md:w-1/3' : 'md:w-1/2',
              weeklyReportDetails.deviation ? 'graph-child' : 'graph-child-half'
            ]"
          >
            <div class="flex flex-col relative w-full">
              <div class="text-center p-4 bg-accent-900 rounded-t-md">
                <span class="text-md font-bold">{{ 'Financials' | transloco }}</span>
              </div>
              <div class="flex flex-col items-center relative p-4 bg-accent-900 rounded-b-md">
                <apx-chart
                  #pieChartRef
                  [chart]="pieChartOptions.chart"
                  [colors]="pieChartOptions.colors"
                  [labels]="pieChartOptions.labels"
                  [plotOptions]="pieChartOptions.plotOptions"
                  [series]="pieChartOptions.series"
                  [states]="pieChartOptions.states"
                  [stroke]="pieChartOptions.stroke"
                  [dataLabels]="pieChartOptions.dataLabels"
                  [legend]="pieChartOptions.legend"
                  [tooltip]="pieChartOptions.tooltip"
                ></apx-chart>
              </div>
            </div>
          </div>

          <!-- Deviation Graph -->
          <div
            *ngIf="weeklyReportDetails?.deviation"
            class="flex w-full md:w-1/3 justify-center rounded-md graph-child"
            id="lineChart"
          >
            <div class="flex flex-col w-full">
              <div class="text-center p-4 bg-accent-900 rounded-t-md">
                <span class="text-md font-bold">{{ 'Deviation' | transloco }}</span>
              </div>
              <img
                [src]="weeklyReportDetails?.deviation"
                class="flex-container w-full report-images"
                style="width: 355px"
              />
            </div>
          </div>
        </div>

        <!--Achievements-->
        <div
          class="flex flex-col w-full p-4 bg-accent-900 rounded-md add-space achievements"
          *ngIf="dataSourceAchievements && dataSourceAchievements.length > 0"
          [class.add-space-after]="!dataSourceChallenges || dataSourceChallenges.length === 0"
        >
          <span class="flex flex-row w-full justify-center font-bold my-2">{{
            'Achievements' | transloco
          }}</span>

          <table
            mat-table
            [dataSource]="dataSourceAchievements"
            class="print:hidden w-full mat-elevation-z8 table table-fixed"
          >
            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef class="mat-column-index">#</th>
              <td mat-cell *matCellDef="let element; let i = index" class="mat-column-index">
                {{ i + 1 }}
              </td>
            </ng-container>

            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef class="mat-column-description">
                {{ 'Description' | transloco }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="mat-column-description table-cell break-words overflow-hidden"
              >
                {{ element.description | titlecase }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef class="mat-column-status">
                {{ 'Status' | transloco }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="mat-column-status table-cell break-words overflow-hidden"
              >
                {{ element.status | titlecase }}
              </td>
            </ng-container>

            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef class="mat-column-date">
                {{ 'Date' | transloco }}
              </th>
              <td mat-cell *matCellDef="let element" class="mat-column-date">
                {{ getDate(element.date) | dateTransform: 'YYYY-MM-DD' : true }}
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="achivementDisplayedColumns"
              class="bg-accent-600"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: achivementDisplayedColumns"
              class="example-element-row"
            ></tr>
          </table>
          <!--Print only achievements-->
          <div
            *ngFor="let element of dataSourceAchievements; let i = index"
            class="achievement-item print-only flex flex-row"
          >
            <!-- Index -->
            <div
              class="w-10 flex flex-row items-center"
              [ngClass]="
                translateService.getActiveLang() === 'en' ? 'bordered-right' : 'bordered-left'
              "
            >
              <strong>#</strong>
              <span>{{ i + 1 }}</span>
            </div>

            <!-- Description -->
            <div
              class="achievement-field mat-column-description"
              [ngClass]="
                translateService.getActiveLang() === 'en' ? 'bordered-right' : 'bordered-left'
              "
            >
              <strong>{{ 'Description' | transloco }}</strong>
              <p class="break-long-line">
                {{ element.description | titlecase }}
              </p>
            </div>

            <!-- Status -->
            <div
              class="achievement-field mat-column-status flex flex-col"
              [ngClass]="
                translateService.getActiveLang() === 'en' ? 'bordered-right' : 'bordered-left'
              "
            >
              <strong>{{ 'Status' | transloco }}</strong>
              <span>{{ element.status | titlecase }}</span>
            </div>

            <!-- Date -->
            <div class="achievement-field mat-column-date flex flex-col">
              <strong>{{ 'Date' | transloco }}</strong>
              <span>{{ getDate(element.date) | dateTransform: 'YYYY-MM-DD' : true }}</span>
            </div>
          </div>
          <!-- Index -->
        </div>

        <!--Challenges-->
        <div
          class="flex flex-col w-full p-4 bg-accent-900 rounded-md challenges add-space-after"
          [class.add-space]="!dataSourceAchievements || dataSourceAchievements.length === 0"
          *ngIf="dataSourceChallenges && dataSourceChallenges.length > 0"
        >
          <span class="flex flex-row w-full justify-center font-bold my-2">{{
            'Challenges' | transloco
          }}</span>

          <table
            mat-table
            [dataSource]="dataSourceChallenges"
            class="w-full mat-elevation-z8 rounded-md print:hidden table table-fixed"
          >
            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef class="mat-column-index">#</th>
              <td mat-cell *matCellDef="let element; let i = index" class="mat-column-index">
                {{ i + 1 }}
              </td>
            </ng-container>

            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef class="mat-column-description">
                {{ 'Description' | transloco }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="mat-column-description table-cell break-words overflow-hidden"
              >
                {{ element.description | titlecase }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef class="mat-column-action">
                {{ 'Status' | transloco }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="mat-column-action table-cell break-words overflow-hidden"
              >
                {{ element.status | titlecase }}
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="mat-column-action">
                {{ 'Taken Action' | transloco }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="mat-column-action table-cell break-words overflow-hidden"
              >
                {{ element.actionNeeded | titlecase }}
              </td>
            </ng-container>

            <ng-container matColumnDef="closingDate">
              <th mat-header-cell *matHeaderCellDef class="mat-column-date">
                {{ 'Closing Date' | transloco }}
              </th>
              <td mat-cell *matCellDef="let element" class="mat-column-date">
                {{ getDate(element.date) | dateTransform: 'YYYY-MM-DD' : true }}
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="challengeDisplayedColumns"
              class="bg-accent-600"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: challengeDisplayedColumns"
              class="example-element-row"
            ></tr>
          </table>
          <!--Print challenges-->
          <div
            *ngFor="let element of dataSourceChallenges; let i = index"
            class="achievement-item print-only flex flex-row"
          >
            <!-- Index -->
            <div
              class="w-10 flex flex-row items-center"
              [ngClass]="
                translateService.getActiveLang() === 'en' ? 'bordered-right' : 'bordered-left'
              "
            >
              <strong>#</strong>
              <span>{{ i + 1 }}</span>
            </div>

            <!-- Description -->
            <div
              class="achievement-field mat-column-description"
              [ngClass]="
                translateService.getActiveLang() === 'en' ? 'bordered-right' : 'bordered-left'
              "
            >
              <strong>{{ 'Description' | transloco }}</strong>
              <p>
                {{ element.description | titlecase }}
              </p>
            </div>

            <!-- Status -->
            <div
              class="achievement-field mat-column-status flex flex-col"
              [ngClass]="
                translateService.getActiveLang() === 'en' ? 'bordered-right' : 'bordered-left'
              "
            >
              <strong>{{ 'Status' | transloco }}</strong>
              <span>{{ element.status | titlecase }}</span>
            </div>

            <!-- Taken Action -->
            <div
              class="achievement-field mat-column-status flex flex-col"
              [ngClass]="
                translateService.getActiveLang() === 'en' ? 'bordered-right' : 'bordered-left'
              "
            >
              <strong>{{ 'Taken Action' | transloco }}</strong>
              <span>{{ element.actionNeeded | titlecase }}</span>
            </div>

            <!-- Closing Date -->
            <div class="achievement-field mat-column-date flex flex-col">
              <strong>{{ 'Closing Date' | transloco }}</strong>
              <span>{{ getDate(element.date) | dateTransform: 'YYYY-MM-DD' : true }}</span>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="commentId" class="print:hidden">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'Comment Thread' | transloco }}
          <span class="text-secondary ms-2">{{ '(' + weeklyReportComments?.length + ')' }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <app-comments
        [mentionableUsersList]="mentionableUsersList"
        [replyPermission]="getCommentPermission()"
        [loading]="isLoading"
        (userMentionedEmitter)="setUserMentioned($event)"
        [comments]="weeklyReportComments"
        [observationReplies]="weeklyReportComments"
        (initializeMentionableUsers)="initializeMentionableUsers($event)"
        [id]="reportId || reportIdOutsideComponent"
        (replyAttachments)="setAttachments($event)"
        [isUploadShown]="isUploadShown"
        (addReply)="addReply($event)"
        (download)="downloadFile($event)"
        [commentId]="commentId"
      ></app-comments>
    </mat-expansion-panel>
  </mat-accordion>
</div>
